import { gql } from "@apollo/client";

const interviewQuestionAiVideoTaskFields = `
  taskId
  status
  submittedById
  submittedByName
  submittedAt
  confirmedAt
  confirmedById
  confirmedByName
  videoUrl
  videoUrlCaption
  thumbnailUrl
  errorMessage
`;

const interviewQuestionFields = `
  id
  uuid
  title
  description
  descriptionJson
  responsesCount
  video
  thumbnail
  position
  enabled
  timeLimitSeconds
  aiVideoGenerationTask {
    ${interviewQuestionAiVideoTaskFields}
  }
`;

const interviewResponseAnswerFields = `
  id
  interviewResponseAnswerId
  title
  description
  score
  notes
  videoUrl
  thumbnailUrl
  transcript
  transcriptHash
  transcriptSummary
  transcriptSummaryHash
  geoLocation {
    city
    cityConfidence
    region
    regionConfidence
    regionIsoCode
    country
    countryConfidence
    countryIsoCode
    anonymizationDetected
    anonymizationData {
      confidence
      isAnonymous
      isAnonymousVpn
      isHostingProvider
      providerName
      networkLastSeen
    }
  }
`;

const INTERVIEW_QUESTION_FIELDS = gql`
  fragment InterviewQuestionFields on InterviewQuestion {
    ${interviewQuestionFields}
  }
`;

const INTERVIEW_RESPONSE_ANSWER_FIELDS = gql`
  fragment InterviewResponseAnswerFields on InterviewResponseAnswer {
    ${interviewResponseAnswerFields}
  }
`;

const INTERVIEW_QUESTION_AI_VIDEO_TASK_FIELDS = gql`
  fragment InterviewQuestionAiVideoTaskFields on InterviewQuestionAiVideoTask {
    ${interviewQuestionAiVideoTaskFields}
  }
`;

export { INTERVIEW_QUESTION_FIELDS, INTERVIEW_RESPONSE_ANSWER_FIELDS, INTERVIEW_QUESTION_AI_VIDEO_TASK_FIELDS };
